var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerificationInidicator(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6,
    fill: "#FFE7FB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.71875 16C7.71875 11.4437 11.4124 7.75 15.9688 7.75C20.5251 7.75 24.2188 11.4437 24.2188 16C24.2188 20.5563 20.5251 24.25 15.9688 24.25C11.4124 24.25 7.71875 20.5563 7.71875 16ZM15.9688 6.25C10.584 6.25 6.21875 10.6152 6.21875 16C6.21875 21.3848 10.584 25.75 15.9688 25.75C21.3535 25.75 25.7188 21.3848 25.7188 16C25.7188 10.6152 21.3535 6.25 15.9688 6.25ZM16.7188 13C16.7188 12.5858 16.383 12.25 15.9688 12.25C15.5545 12.25 15.2188 12.5858 15.2188 13V16.75C15.2188 17.1642 15.5545 17.5 15.9688 17.5C16.383 17.5 16.7188 17.1642 16.7188 16.75V13ZM15.9688 19C15.5545 19 15.2188 19.3358 15.2188 19.75V19.7575C15.2188 20.1717 15.5545 20.5075 15.9688 20.5075H15.9762C16.3905 20.5075 16.7262 20.1717 16.7262 19.7575V19.75C16.7262 19.3358 16.3905 19 15.9762 19H15.9688Z",
    fill: "#A614B9"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerificationInidicator);
export default __webpack_public_path__ + "static/media/verification-inidicator.fd353379d5d9026cfb4252078b743647.svg";
export { ForwardRef as ReactComponent };